import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentOptionsService } from 'src/app/public-website/buyer/services/payment-options.service';
import Swal from 'sweetalert2';
import { FetchBussinesService } from '../../../report/services/fetch-bussines.service';
import { ManualPaymentsCreateService } from '../../../report/services/manual-payments-create.service';

@Component({
  selector: 'app-manual-payment',
  templateUrl: './manual-payment.component.html',
  styleUrls: ['./manual-payment.component.scss'],
})
export class ManualPaymentComponent implements OnInit {
  paymentForm: FormGroup;
  businesses = [];
  paymentOptions = [];

  constructor(
    private paymentOptionsService: PaymentOptionsService,
    private fetchBusiness: FetchBussinesService,
    private manualPaymentsCreateService: ManualPaymentsCreateService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.paymentForm = new FormGroup({
      business: new FormControl('', Validators.required),
      paymentOption: new FormControl('', Validators.required),
      amount: new FormControl('', [Validators.required, Validators.min(0)]),
      buyerName: new FormControl('', Validators.required),
      buyerEmail: new FormControl('', [Validators.required, Validators.email]),
      buyerMobile: new FormControl('', Validators.required),
      description: new FormControl(''),
      providerReference: new FormControl(''),
    });

    let res = await this.fetchBusiness.make();
    this.businesses = res.result;
  }

  async onSubmit(): Promise<void> {
    if (!this.paymentForm.valid) {
      return;
    }
    const formData = this.paymentForm.value;
    const requestBody = {
      businessId: formData.business,
      paymentOptionId: formData.paymentOption,
      amount: formData.amount,
      buyerInfos: {
        name: formData.buyerName,
        email: formData.buyerEmail,
        mobile: formData.buyerMobile,
      },
      description: formData.description || undefined,
      providerReference: formData.providerReference || undefined,
    };

    try {
      this.manualPaymentsCreateService.setParams(requestBody);
      const response = await this.manualPaymentsCreateService.make();
      Swal.fire('Success', response.message, 'success');
    } catch (error) {
      console.log(error);
      if (error.validationErrors) {
        const e = error.validationErrors.error;
        Swal.fire('Error', e[0].message, 'error');
        return;
      }
      Swal.fire('Error', error.message, 'error');
    }
  }

  async displayPaymentMethod(event: number) {
    this.paymentForm.controls['business'].setValue(event);
    this.paymentOptionsService.setParams({ id: event, isManualPayment: true });
    this.paymentOptions = await this.paymentOptionsService.make();
  }
}
